// app-config.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

interface Config {
  url: string;
  name: string;
}
export interface IAppConfig {
  api_url: string;
  cliente: string;
  baseUrl: string;
  baseDMUrl: string;
  baseStandardUrl: string;
  load: () => Promise<void>;
}
@Injectable()
export class AppConfig implements IAppConfig {
  public baseUrl: string;
  public api_url: string;
  public cliente: string;
  public baseDMUrl: string;
  public baseStandardUrl: string;
constructor(private readonly http: HttpClient) {}
public load(): Promise<void> {
    return this.http
      .get<Config>('assets/config.json')
      .toPromise()
      .then(config => {
        this.baseUrl = config.url;
        this.api_url  = config.url;
        this.cliente = config.name;
      })
      .catch(err => {
        //Si da error se cargan los valores del enviroment
        console.log(err);
        this.baseUrl = environment.api_url;
        this.api_url  = environment.api_url;
        this.cliente = environment.cliente;
    });
  }

  public getApiUrl():string{
    return this.api_url;
  }
}



export function initConfig(config: AppConfig): () => Promise<void> {
  return () => config.load();
}
